


import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class ItiSteeperPreviousNext extends Vue {
  @Prop({ default: false }) public previousHidden!: boolean;
  @Prop({ default: false }) public nextHidden!: boolean;
  @Prop({ default: 'arrow_back' }) public previousIcon!: string;
  @Prop({ default: 'arrow_forward' }) public nextIcon!: string;

  constructor() {
    super();
  }
}
